import { useSelector } from "react-redux";
import {
  getStateOfStockExemptions,
  selectState,
} from "../slices/dtStockExemption.slice";
import { useAppDispatch } from "hooks/hooks";
import { useCallback, useEffect, useState } from "react";
import { IStockExemption } from "../domain/IStockExemption";
import Loader from "components/Loader/Loader";
import DateSelector from "Dashboard/components/DateSelector";
import { FormatDateIso, FormatDateShort } from "utils/dateUtils";
import { FormatNumberOrNull, FormatNumberWithUnitOrNull } from "utils/numberUtils";
import InfoTooltip from "components/Popup/InfoTooltip";

export const StockExemptionPreview = () => {
  const { stockExemptions, loading } = useSelector(selectState);
  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [dateTo, setDateTo] = useState<Date | null>(null);
  const dispatch = useAppDispatch();

  const selectDate = useCallback((data: { dateFrom: Date; dateTo: Date }) => {
    setDateFrom(data.dateFrom);
    setDateTo(data.dateTo);
  }, []);

  useEffect(() => {
    if (dateFrom && dateTo) {
      dispatch(
        getStateOfStockExemptions({
          dateFrom: FormatDateIso(dateFrom),
          dateTo: FormatDateIso(dateTo),
        }));
    }
  }, [dispatch, dateFrom, dateTo]);

  return (
    <div className="daily-table-stock-outputs loading-container">
      {loading && <Loader />}
      <div className="previewHeader">
        <div className="bolded red">LAGER IZLAZ</div>
        <div>
          <DateSelector showYear={false} selectDate={selectDate} />
        </div>
      </div>
      <div className="extendedPreviewBody">
        {stockExemptions.map((exemption: IStockExemption) => (
          <div className="singleLagerOutput">
            <InfoTooltip
              tooltip={exemption.itemName}
              classesProp="daily-table-stock-outputs-item"
              element="span"
            >{
                exemption.itemName}
            </InfoTooltip>
            <span className="daily-table-stock-outputs-quantity">{FormatNumberOrNull(exemption.quantityAmount)}</span>
            <span className="daily-table-stock-outputs-quantity-label">izdato</span>
            <span className="daily-table-stock-outputs-price">{FormatNumberWithUnitOrNull(exemption.exemptionPrice, 'rsd')}</span>
            <span className="daily-table-stock-outputs-price-label">cena</span>
            <span className="daily-table-stock-outputs-date">{FormatDateShort(exemption.date)}</span>
          </div>
        ))}
        {stockExemptions.length < 4 && (
          <div className="singleLagerOutput"></div>
        )}
        {stockExemptions.length < 3 && (
          <div className="singleLagerOutput"></div>
        )}
        {stockExemptions.length < 2 && (
          <div className="singleLagerOutput"></div>
        )}
        {stockExemptions.length < 1 && (
          <div className="singleLagerOutput"></div>
        )}
      </div>
    </div>
  );
};
